<!--
* @Name：HiCell
* @Author: 刘玉
* @Date: 2022-01-04 18:50:57
* @Last Modified by: 刘玉
* @Last Modified time: 2022-01-04 18:50:57
-->
<template>
  <van-cell>
    <span class="title">{{ title }}</span>
    <span class="value">{{ value | dictFilter(options) }}</span>
  </van-cell>
</template>

<script>
export default {
  name: 'HiCell',
  props: ['title', 'value', 'options']
}
</script>
<style lang="scss" scoped>
.title {
  color: #909399;
  font-size: 17px;
}
.value {
  color: #000000;
  font-size: 17px;
}
</style>
